export default __webpack_public_path__ + "static/media/404.6f0218a6.png";